import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

interface CompleteWorkflowParams {
  clientId: string;
}

const completeWorkflow = ({ clientId }: CompleteWorkflowParams) => {
  return authFetch(
    urlWithParams('/Consumer/RiskToleranceWorkflowUpdate/CompleteWorkflow', {
      clientId,
    }),
    { method: 'POST' },
  );
};

export const useCompleteWorkflowMutation = () => {
  return useMutation(completeWorkflow);
};
